import React from 'react';
import PropTypes from 'prop-types';

import GraphTitle from 'app/shared/components/Graphs/GraphTitle';
import GraphEmptyMessage from 'app/shared/components/Graphs/GraphEmptyMessage';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import GraphConstants from 'app/shared/constants/GraphConstants';

import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from 'recharts';

const propTypes = {
    brand: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
};

const defaultProps = {
    isLoading: false,
};

const GRAPH = GraphConstants.GRAPHS.REVIEW;
const TABS = GraphConstants.GRAPH_TABS;

const AVERAGE_DOMAIN = [0, 5];
const AUTO_DOMAIN = ['auto', 'auto'];
const AVERAGE_TICKS = [0, 1, 2, 3, 4, 5];

class ReviewGraph extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: TABS.AVERAGE,
        };
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    handleTabClick(index) {
        this.setState({ activeTab: index === 0 ? TABS.AVERAGE : TABS.TOTAL });
    }

    renderGraph(currentData, activeKey) {
        const { brand } = this.props;
        const { activeTab } = this.state;
        const isAverage = activeTab === TABS.AVERAGE;
        const domain = isAverage ? AVERAGE_DOMAIN : AUTO_DOMAIN;
        const ticks = isAverage ? AVERAGE_TICKS : null;
        return (
            <div className="Graph-container">
                {currentData.isEmpty && <GraphEmptyMessage message="No reviews available" />}
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={currentData.months} key={activeKey}>
                        <XAxis dataKey="name" />
                        <YAxis domain={domain} ticks={ticks} />
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <Tooltip />
                        <Line
                            dataKey={activeKey}
                            stroke={GraphConstants.COLORS[brand].secondary}
                            dot={{ r: 5, fill: GraphConstants.COLORS[brand].secondary }}
                            activeDot={{ r: 8 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    }

    render() {
        const {
            isLoading,
            data,
        } = this.props;
        const { activeTab } = this.state;

        const configs = GRAPH[activeTab];
        const activeKey = configs.DATA_KEY;
        const currentData = data[configs.DATA_TYPE];
        const number = currentData[activeKey];
        const displayNumber = (isLoading || number === '0.0' || number === '0') ? '-' : number;
        const title = `${configs.TITLE_PREFIX}: ${displayNumber}${activeTab === TABS.AVERAGE ? '/5' : ''}`;

        return (
            <div className="Graph">
                <GraphTitle
                    title={title}
                    isLoading={isLoading}
                    showTabs={true}
                    onTabClick={this.handleTabClick}
                    activeIndex={configs.TAB_INDEX}
                    firstTabTitle="Ratings"
                    secondTabTitle="# of reviews"
                />
                {isLoading ?
                    <SpinnerContainer customClass="Graph-Spinner" /> :
                    this.renderGraph(currentData, activeKey)
                }
            </div>
        );
    }
}

ReviewGraph.propTypes = propTypes;
ReviewGraph.defaultProps = defaultProps;

export default ReviewGraph;
